import { Injectable } from '@angular/core';
import { VueAppDefaultsService } from '@vue/vueframework';
import { AppConfigService } from './shared/services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class AppDefaultsService extends VueAppDefaultsService {
  public constructor(private appConfig: AppConfigService,) {
    super();
  }

  public getBaseAppHelpURL(): string {
    return '/WebHelp/Prerequisites/index.htm';
  }

  public getDefaultHelpURL(): string {
    return '/WebHelp/Prerequisites/index.htm';
  }

  public getIsOAuthEnabled(): boolean {
    return false;
  }

  public getInactivityTimeout(): number {
    return 14;
  }

  public getInactivityTimeoutLogging(): boolean {
    return false;
  }

  // todo: Remove this once vueframework getting from portalbase
  public getPortalMessageBundle(): string {
    return 'Navigator';
  }

  public getDefaultPageTitle(): string {
    return 'Pearson VUE - Account Recovery';
  }

  public getDefaultLocale(): string {
    return 'en_US';
  }

  public getIsRestRootUsedForXliff(): boolean {
    return false;
  }

  public getXliffBaseURL(): string {
    return this.appConfig.getXliffUrl();
  }
  
  public getXliffHostingType(): string {
    return 'cdn';
  }
}
